import DeviceCatalogue from "../components/DeviceCatalogue/DeviceCatalogue";

type Props = {};

export default function DeviceCataloguePage({}: Props) {
  return <DeviceCatalogue />;
}
